import { combineReducers, configureStore} from "@reduxjs/toolkit";
// import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import createSagaMiddleware from "redux-saga";
import routerReducer from "../features/router/routerSlice";
import rootSaga from "./rootSaga";
import getApiRoutesReducer from "../features/api_routes/apiRouterSlice";
import getApiNodePointsReducer from "../features/api_node_points/apiNodePointsSlice";



const sagaMiddleware = createSagaMiddleware();

// Optional: type for saga middleware
type SagaMiddlewareType = ReturnType<typeof createSagaMiddleware>;

const rootReducer = combineReducers({
  router: routerReducer,
  getApiRoutes : getApiRoutesReducer,
  getApiNodePoints: getApiNodePointsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware : any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
